import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
import * as Pedidos from '../';
import { IResumenPublicacionesMercadoLibre } from './Resumen.lib';
import moment from 'moment';

export class ResumenPublicacionesMercadoLibre extends IResumenPublicacionesMercadoLibre
{

    public static async create( cuenta: string = null ): Promise<ResumenPublicacionesMercadoLibre>
    {
        let o = new ResumenPublicacionesMercadoLibre();
        o.Cuenta = cuenta;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/mercadolibre/publicaciones/estadistica';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        if ( this.Cuenta )
            request.params.cuenta = this.Cuenta;
        request.path = `${this.Route}`;

        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }


}
